import React from 'react';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';

export const PAGE_SIZE = 10;

export default function Pagination({ page, total, pageSize = PAGE_SIZE, onChange }) {
  if (!total) return null;

  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = (page - 1) * pageSize + 1;
  const end   = Math.min(page * pageSize, total);

  // Build page numbers: always show first, last, current ±1, and ellipsis gaps
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '…') {
      pages.push('…');
    }
  }

  return (
    <div className="flex items-center justify-between px-6 py-3 border-t border-[#F3F4F6] bg-[#FAFBFC]">
      <p className="text-xs text-[#9CA3AF]">
        Showing <span className="font-semibold text-[#374151]">{start}–{end}</span> of{' '}
        <span className="font-semibold text-[#374151]">{total}</span>
      </p>
      {totalPages <= 1 ? <span /> : (
      <div className="flex items-center gap-1">
        <button
          onClick={() => onChange(page - 1)}
          disabled={page === 1}
          className="w-7 h-7 flex items-center justify-center rounded-lg border border-[#E5E7EB] text-[#6B7280] hover:text-[#0984e3] hover:border-[#0984e3] disabled:opacity-40 disabled:cursor-not-allowed transition-all cursor-pointer"
        >
          <RiArrowLeftSLine size={15} />
        </button>

        {pages.map((p, i) =>
          p === '…' ? (
            <span key={`e${i}`} className="w-7 h-7 flex items-center justify-center text-xs text-[#9CA3AF]">…</span>
          ) : (
            <button
              key={p}
              onClick={() => onChange(p)}
              className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-semibold transition-all cursor-pointer ${
                p === page
                  ? 'text-white shadow-[0_4px_10px_rgba(9,132,227,0.3)]'
                  : 'border border-[#E5E7EB] text-[#6B7280] hover:text-[#0984e3] hover:border-[#0984e3]'
              }`}
              style={p === page ? { background: 'linear-gradient(135deg,#0984e3,#00b0ff)' } : {}}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={() => onChange(page + 1)}
          disabled={page === totalPages}
          className="w-7 h-7 flex items-center justify-center rounded-lg border border-[#E5E7EB] text-[#6B7280] hover:text-[#0984e3] hover:border-[#0984e3] disabled:opacity-40 disabled:cursor-not-allowed transition-all cursor-pointer"
        >
          <RiArrowRightSLine size={15} />
        </button>
      </div>
      )}
    </div>
  );
}
